export default __webpack_public_path__ + "static/media/letter-x.de2c2158.png";